import { useMutation } from "react-query";
import { addSingleHvac } from "../../../../actions/CarrierAgreementMgmt/Security";

const useAddSingleHvac = () => {
  return useMutation(addSingleHvac);
};
export default useAddSingleHvac;
